import React from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";

import { FETCH_SEARCH_RESULTS_FAILURE } from "@safecv/actions/types";

import "./IconSidebar.css";

import symbolsIcon from "@safecv/assets/Images/symbols.svg";
import pdfSearchIcon from "@safecv/assets/Images/pdf_search.svg";
import annotationIcon from "@safecv/assets/Images/annotation.svg";
import complianceIcon from "@safecv/assets/Images/compliance.svg";

const IconSidebar = (props) => {
  const dispatch = useDispatch();
  const searchPayload = useSelector(
    (state) => state.verification.searchResults,
    shallowEqual
  );
  const {
    setViewType,
    selectedView,
    setOpenSidebar,
    setSelectedView,
    setIsSearchEnable,
    setIsDiscardedOpen,
    selectedCompliancesCheckboxValue,
    isPlanTypeCommercial,
    algoEnabled,
  } = props;

  const sidebarData = [
    {
      image: annotationIcon,
      title: "Annotations",
      type: "viewType",
      value: "annotated",
      visibility: true,
    },
    {
      image: complianceIcon,
      title: "Compliances",
      type: "viewType",
      value: [
        "compliance,violation",
        "compliance",
        "violation",
        "violation,compliance",
      ],
      visibility: algoEnabled && !isPlanTypeCommercial,
    },
    {
      image: symbolsIcon,
      title: "Switch to Symbols",
      type: "viewType",
      value: "symbols",
      visibility: algoEnabled && !isPlanTypeCommercial,
    },
    {
      image: pdfSearchIcon,
      title: "Search",
      type: "search",
      value: ["basicPdfSearch", "enhancedSearch"],
      visibility: algoEnabled,
    },
  ];

  const setDisplayContainer = (item) => {
    if (item.type === "viewType") {
      if (item.title === "Compliances") {
        setSelectedView(selectedCompliancesCheckboxValue?.join(","));
        setViewType(selectedCompliancesCheckboxValue?.join(","));
      } else {
        setSelectedView(item.value);
        setViewType(item.value);
      }
      setIsSearchEnable(false);
    } else {
      searchPayload && dispatch({ type: FETCH_SEARCH_RESULTS_FAILURE });
      setViewType(item.value[0]);
      setIsSearchEnable(true);
    }
    setOpenSidebar(false);
    setIsDiscardedOpen(false);
  };

  return (
    <div className="sidebar-container">
      {sidebarData.map((item, index) => {
        return (
          <React.Fragment key={index}>
            {item.visibility && (
              <div
                className="sidebar-item-container"
                onClick={() => setDisplayContainer(item)}
              >
                <img
                  src={item.image}
                  alt=""
                  className={
                    item.value.includes(selectedView)
                      ? "selected-sidebar-image"
                      : ""
                  }
                />
                <div
                  className={
                    item.value.includes(selectedView)
                      ? "selected-sidebar-item text"
                      : "text"
                  }
                >
                  {item.title}
                </div>
                {item.value.includes("symbols") ? (
                  <div className="line-divider"></div>
                ) : null}
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default IconSidebar;
